import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { currentRouteSet } from "../actions/actions";
import { pathSpliter } from "../lib/functions";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import { APP_URL, API_URL } from "../config";
import "./global.css";
import axios from "axios";

// Keep your icon imports same
import Sales2 from "../assets/icons2/sales.png";
import Service2 from "../assets/icons2/service.png";
import Purchase2 from "../assets/icons2/Purchase.png";
import Manufacturing2 from "../assets/icons2/Manufacturing.png";
import Inventory2 from "../assets/icons2/Inventory.png";
import Accounts2 from "../assets/icons2/Accounts.png";
import Hr2 from "../assets/icons2/Hr& Payroll.png";
import Report2 from "../assets/icons2/Report.png";
import CRM2 from "../assets/icons2/CRM.png";
import Settings2 from "../assets/icons2/Setting.png";
import { quartersInYear } from "date-fns";

const useStyles = makeStyles((theme) => ({
  box: {
    color: "#e1f8fb",
    height: "177px",
    margin: "0px",
    background: "#23B7A7",
    textAlign: "center",
    textDecoration: "none",
    borderRadius: "20px",
    marginTop: "10px",
    width: "23%",
    margin: "1%",
    [theme.breakpoints.down('md')]: {
      width: "46%",
      margin: "2%",
      height: "140px",
    },
    [theme.breakpoints.down('xs')]: {
      width: "100%",
      margin: "4px 0",
      height: "auto",
      minHeight: "80px",
      borderRadius: "12px",
    },
  },
  boxTitle: {
    color: "#484848",
    fontWeight: "bold",
    fontSize: "18px",
    margin: "0px",
  },
  dashboardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "15px",
    borderRadius: "8px",
    flexWrap: "wrap",
    gap: "8px",
    [theme.breakpoints.down('xs')]: {
      flexDirection: "column",
      padding: "8px",
    },
  },
  headerLeft: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  headerRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "4px",
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",     // two main divs in one column
    gap: "20px",
    margin: "20px 0",
  },

  // New: makes the child tables sit in one horizontal row (desktop), stack on small screens
  rowWrap: {
    display: "flex",
    gap: "20px",
    alignItems: "stretch",
    flexWrap: "wrap",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      gap: "12px",
    },
  },
  summaryTable: {
    borderRadius: "2px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    flex: "1 1 300px",
    minWidth: 0,
    overflowX: "auto",
  },

  tableHeader: {
    padding: "10px",
    color: "white",
    fontWeight: "bold",
    fontSize: "0.95rem",
    textAlign: "center",
  },
  tableCell: {
    padding: "8px 12px",
    fontSize: "0.85rem",
    lineHeight: "1.2",
    border: "2px solid #DDDDDD",
  },
  serialNumber: {
    fontWeight: "500",
  },
  timeDateContainer: {
    fontSize: "clamp(16px, 4vw, 30px)",
    color: "#0F7E77",
    marginTop: "4px",
    fontFamily: "Roboto",
    fontWeight: "700"
  },

  branch: {
    fontSize: "16px",
    color: "#378100",
    fontFamily: "Consolas",
    fontWeight: "700"
  },
  dateContainer: {
    fontSize: "20px",
    color: "#0F7E77",
    marginTop: "4px",
    fontFamily: "Roboto",
    fontWeight: "700"
  },

  profile: {
    fontSize: "12px",
    color: "#378100",
    fontFamily: "Comic Sans MC",
    fontWeight: "700"
  },
  profitPositive: {
    color: "#28a745",
    fontWeight: "bold",
  },
  profitNegative: {
    color: "#dc3545",
    fontWeight: "bold",
  },
  "@global": {
    ".MuiBox-root": {
      paddingBottom: "0px !important",
      paddingTop: "2px",
    },
    ".MuiBox-root p": {
      color: "white",
    },
    ".MuiBox-root svg": {
      color: "white",
      fontWidth: "bold",
    },
  },
}));

const Dashboard = ({ location, currentRoute, currentRouteSet, authInfo }) => {
  const userInfo = authInfo?.userInfo || {};
  const branchName = userInfo.branch_name || "";
  const warehouseName = userInfo.warehouse_name || "";
  const userFullName = userInfo.user_full_name || userInfo.full_name || userInfo.user_name || "";
  const [summaryData, setSummaryData] = useState({
    customerDue: 0,
    dueCollection: 0,
    supplierDue: 0,
    duePayment: 0,
    sales: 0,
    expense: 0,
    profitLoss: 0,
  });
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [profile, setProfile] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const classes = useStyles();
  const monthRange = 4
  const [salesData, setSalesData] = useState([])
  const [purchaseData, setPurchaseData] = useState([])
  const [quotationData, setQuotationData] = useState([])

  const [balanceData, setBalanceData] = useState({
    cashInHand: 0,
    bankAccounts: 0,
    customerDue: 0,
    supplierDue: 0
  })

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    fetchSummaryData();
    fetchSalesData();
    fetchPurchaseData();
    fetchQuotationData();
    fetchBalanceData()
    fetchProfile();

    const dataInterval = setInterval(fetchSummaryData, 3600000);
    const timeInterval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(dataInterval);
      clearInterval(timeInterval);
    };
  }, [location.pathname]);

  const fetchSalesData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(`${API_URL}/api/get-monthly-sales`,
        { monthRange: monthRange },
        { headers: { "auth-token": authInfo.token } })

      setSalesData(response.data.message)
      setLoading(false);
    } catch (error) {
      console.error("Error fetching sales data: ", error)
      setLoading(false);
    }
  }

  const fetchPurchaseData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(`${API_URL}/api/get-monthly-purchases`,
        { monthRange: monthRange },
        { headers: { "auth-token": authInfo.token } })

      setPurchaseData(response.data.message)
      setLoading(false);
    } catch (error) {
      console.error("Error fetching purchase data: ", error)
      setLoading(false);
    }
  }

  const fetchQuotationData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(`${API_URL}/api/get-monthly-quotations`,
        { monthRange: monthRange },
        { headers: { "auth-token": authInfo.token } })

      setQuotationData(response.data.message)
      setLoading(false);
    } catch (error) {
      console.error("Error fetching quotation data: ", error)
      setLoading(false);
    }
  }

  const fetchBalanceData = async () => {
    try {
      setLoading(true);
      const headers = { "auth-token": authInfo.token };

      const responses = await Promise.all([
        axios.post(`${API_URL}/api/get-customer-due`, null, { headers }),
        axios.post(`${API_URL}/api/get-supplier-due`, null, { headers }),
        axios.post(`${API_URL}/api/get-cash-transaction-summary`, null, { headers }),
        axios.post(`${API_URL}/api/get-bank-transaction-summary`, null, { headers })
      ]);

      setBalanceData({
        customerDue: responses[0].data.reduce((prev, curr) => prev + curr.dueAmount, 0).toFixed(2),
        supplierDue: responses[1].data.reduce((prev, curr) => prev + curr.dueAmount, 0).toFixed(2),
        cashInHand: responses[2].data[0].cash_balance,
        bankAccounts: responses[3].data.reduce((prev, curr) => prev + curr.balance, 0).toFixed(2),
      });

      setLastUpdated(new Date().toLocaleTimeString());
      setLoading(false);
    } catch (error) {
      console.error("Error fetching summary data:", error);
      setLoading(false);
    }
  };
  const fetchSummaryData = async () => {
    try {
      setLoading(true);
      const headers = { "auth-token": authInfo.token };
      const getWithFallback = async (urls) => {
        let lastError = null;

        for (const url of urls) {
          try {
            return await axios.get(url, { headers });
          } catch (error) {
            lastError = error;
          }
        }

        throw lastError;
      };

      const responses = await Promise.all([
        getWithFallback([
          `${API_URL}/api/get-today-total-customer-due`,
          `${API_URL}/api/get-today-total-customer-deu`,
        ]),
        getWithFallback([
          `${API_URL}/api/get-today-total-customer-due-payment`,
          `${API_URL}/api/get-today-total-customer-deu-payment`,
        ]),
        axios.get(`${API_URL}/api/get-today-total-supplier-due`, { headers }),
        axios.get(`${API_URL}/api/get-today-total-supplier-due-payment`, { headers }),
        axios.get(`${API_URL}/api/get-today-total-sales`, { headers }),
        axios.get(`${API_URL}/api/get-today-total-expense`, { headers }),
        axios.get(`${API_URL}/api/get-today-total-profit-loss`, { headers }),
      ]);

      setSummaryData({
        customerDue: responses[0]?.data.total_customer_due,
        dueCollection: responses[1]?.data.total_customer_due_payment,
        supplierDue: responses[2]?.data.total_supplier_due,
        duePayment: responses[3]?.data.total_supplier_due_payment,
        sales: responses[4]?.data.total_sales,
        expense: responses[5]?.data.total_expense,
        profitLoss: responses[6]?.data.daily_profit_loss,
      });

      setLastUpdated(new Date().toLocaleTimeString());
      setLoading(false);
    } catch (error) {
      console.error("Error fetching summary data:", error);
      setLoading(false);
    }
  };

  const fetchProfile = async () => {
    try {
      const headers = { "auth-token": authInfo.token };
      const response = await axios.get(`${API_URL}/api/get-institution`, { headers });
      setProfile(response.data.pro_name);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  const formatCurrency = (amount) => {
    return (
      parseFloat(amount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + " TK"
    );
  };

  const getProfitLossClass = (value) => {
    return value < 0 ? classes.profitNegative : classes.profitPositive;
  };

  const formattedDate = currentTime.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Dhaka",
  });

  const formattedTime = currentTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "Asia/Dhaka",
  });

  return (
    <Fragment>
      <div className={classes.dashboardHeader}>
        <div className={classes.headerLeft}>
          <div className={classes.branch}>
            <strong>Branch:</strong> {branchName}
            {warehouseName && ` | Warehouse: ${warehouseName}`}
          </div>
          <div className={classes.branch}>
            <strong>User:</strong> {userFullName}
          </div>
          <div className={classes.timeDateContainer}>
            {formattedTime}
          </div>
        </div>
        <div className={classes.headerRight}>
          <div className={classes.profile}>{profile}</div>
          <div className={classes.dateContainer}>{formattedDate}</div>


        </div>
      </div>

      <div className={classes.summaryGrid}>
        {authInfo.role != "user" && (
          <div className={classes.rowWrap}>
            {/* Today's Summary Table */}
            <div className={classes.summaryTable}>
              <div style={{ backgroundColor: "#F0A268" }} className={classes.tableHeader}>
                Today's Summary
                {/* <div style={{ fontSize: "0.75rem", fontWeight: "normal" }}>
                  {loading ? "Loading..." : `Updated: ${lastUpdated}`}
                </div> */}
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr >
                    <th className={classes.tableCell} style={{ width: "50px" }}></th>
                    <th className={classes.tableCell} style={{ textAlign: "left" }}>Account</th>
                    <th className={classes.tableCell} style={{ textAlign: "right" }}>Amount</th>
                  </tr>
                </thead>
                <tbody className={classes.tableBody}>
                  {[
                    ["Customer Due", summaryData.customerDue],
                    ["Due Collection", summaryData.dueCollection],
                    ["Supplier Due", summaryData.supplierDue],
                    ["Due Payment", summaryData.duePayment],
                    ["Total Sales", summaryData.sales],
                    ["Total Expense", summaryData.expense],
                    ["Profit/Loss", summaryData.profitLoss],
                  ].map(([label, value], index) => (
                    <tr key={label}>
                      <td className={`${classes.tableCell} ${classes.serialNumber}`} style={{ textAlign: "center" }}>&#9679;</td>
                      <td className={classes.tableCell} style={{ textAlign: "left" }}>{label}</td>
                      <td className={classes.tableCell} style={{ textAlign: "right" }}>
                        {label === "Profit/Loss" ? (
                          <span className={getProfitLossClass(value)}>
                            {formatCurrency(value)}
                          </span>
                        ) : (
                          formatCurrency(value)
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Balance Summary Table */}
            <div className={classes.summaryTable}>
              <div style={{ backgroundColor: "#537E83" }} className={classes.tableHeader}>Balance Summary</div>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr >
                    <th className={classes.tableCell} style={{ width: "50px" }}></th>
                    <th className={classes.tableCell} style={{ textAlign: "left" }}>Account</th>
                    <th className={classes.tableCell} style={{ textAlign: "right" }}>Balance</th>
                  </tr>
                </thead>
                <tbody className={classes.tableBody}>
                  {[
                    ["Cash In Hand", balanceData.cashInHand],
                    ["Bank Accounts", balanceData.bankAccounts],
                    ["Supplier Due", balanceData.supplierDue],
                    ["Customer Due", balanceData.customerDue],
                  ].map(([label, value], index) => (
                    <tr key={index}>
                      <td className={`${classes.tableCell} ${classes.serialNumber}`} style={{ textAlign: "center" }}>:)</td>
                      <td className={classes.tableCell} style={{ textAlign: "left" }}>{label}</td>
                      <td className={classes.tableCell} style={{ textAlign: "right" }}>{value} TK</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <div className={classes.rowWrap}>
          {/* Sales Last 4 Months Table */}
          <div className={classes.summaryTable}>
            <div style={{ backgroundColor: "#675468" }} className={classes.tableHeader}>{`Sales - Last ${monthRange} Months`}</div>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr >
                  <th className={classes.tableCell} style={{ width: "50px" }}></th>
                  <th className={classes.tableCell} style={{ textAlign: "left" }}>Month</th>
                  <th className={classes.tableCell} style={{ textAlign: "right" }}>Amount</th>
                </tr>
              </thead>
              <tbody className={classes.tableBody}>
                {salesData.map((item, index) => (
                  <tr key={index}>
                    <td className={`${classes.tableCell} ${classes.serialNumber}`} style={{ textAlign: "center" }}>#</td>
                    <td className={classes.tableCell} style={{ textAlign: "left" }}>{item.month_year}</td>
                    <td className={classes.tableCell} style={{ textAlign: "right" }}>{item.total_sale} TK</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Purchase Last 4 Months Table */}
          <div className={classes.summaryTable}>
            <div style={{ backgroundColor: "#675468" }} className={classes.tableHeader}>{`Purchase - Last ${monthRange} Months`}</div>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr >
                  <th className={classes.tableCell} style={{ width: "50px" }}></th>
                  <th className={classes.tableCell} style={{ textAlign: "left" }}>Month</th>
                  <th className={classes.tableCell} style={{ textAlign: "right" }}>Amount</th>
                </tr>
              </thead>
              <tbody className={classes.tableBody}>
                {purchaseData.map((item, index) => (
                  <tr key={index}>
                    <td className={`${classes.tableCell} ${classes.serialNumber}`} style={{ textAlign: "center" }}>#</td>
                    <td className={classes.tableCell} style={{ textAlign: "left" }}>{item.month_year}</td>
                    <td className={classes.tableCell} style={{ textAlign: "right" }}>{item.total_purchase} TK</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Quotation Last 4 Months Table */}
          <div className={classes.summaryTable}>
            <div style={{ backgroundColor: "#675468" }} className={classes.tableHeader}>{`Quotation - Last ${monthRange} Months`}</div>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr >
                  <th className={classes.tableCell} style={{ width: "50px" }}></th>
                  <th className={classes.tableCell} style={{ textAlign: "left" }}>Month</th>
                  <th className={classes.tableCell} style={{ textAlign: "right" }}>Amount</th>
                </tr>
              </thead>
              <tbody className={classes.tableBody}>
                {quotationData.map((item, index) => (
                  <tr key={index}>
                    <td className={`${classes.tableCell} ${classes.serialNumber}`} style={{ textAlign: "center" }}>#</td>
                    <td className={classes.tableCell} style={{ textAlign: "left" }}>{item.month_year}</td>
                    <td className={classes.tableCell} style={{ textAlign: "right" }}>{item.total_quotation} TK</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>

      </div>

      {/* Module Boxes - Keep existing code */}
      {currentRoute === undefined && (
        <div style={{ padding: "20px" }}>
          <div className="modules-box" style={{ marginTop: "65px" }}>
            {/* Sales Module */}
            <div className="module-box" style={{ background: "#16606C" }}>
              <Link to="/sales">
                <Box p={4}>
                  <img
                    src={Sales2}
                    alt="Sales"
                    style={{ width: 40, height: 40, marginTop: 10 }}
                  />

                  <p className={classes.boxTitle}>Sales Module</p>
                </Box>
              </Link>
            </div>

            {/* Service Module */}
            <div className="module-box" style={{ background: "#007CA8" }}>
              <Link to="/service">
                <Box p={4}>
                  <img
                    src={Service2}
                    alt="Service"
                    style={{ width: 40, height: 40, marginTop: 10 }}
                  />
                  <p className={classes.boxTitle}>Service Module</p>
                </Box>
              </Link>
            </div>

            {/* Purchase Module */}
            <div className="module-box" style={{ background: "#5A878C" }}>
              <Link to="/purchase">
                <Box p={4}>
                  <img
                    src={Purchase2}
                    alt="Purchase"
                    style={{ width: 40, height: 40, marginTop: 10 }}
                  />
                  <p className={classes.boxTitle}>Purchase Module</p>
                </Box>
              </Link>
            </div>

            {/* Manufacturing Module */}
            <div className="module-box" style={{ background: "#359E8F" }}>
              <Link to="/production">
                <Box p={4}>
                  <img
                    src={Manufacturing2}
                    alt="Manufacturing"
                    style={{ width: 40, height: 40, marginTop: 10 }}
                  />
                  <p className={classes.boxTitle}>Manufacturing Module</p>
                </Box>
              </Link>
            </div>

            {/* Inventory Module */}
            <div className="module-box" style={{ background: "#E7C372" }}>
              <Link to="/stock">
                <Box p={4}>
                  <img
                    src={Inventory2}
                    alt="Inventory"
                    style={{ width: 40, height: 40, marginTop: 10 }}
                  />
                  <p className={classes.boxTitle}>Inventory Module</p>
                </Box>
              </Link>
            </div>

            {/* Financial Accounts Module */}
            <div className="module-box" style={{ background: "#007CA9" }}>
              <Link to="/accounts">
                <Box p={4}>
                  <img
                    src={Accounts2}
                    alt="Accounts"
                    style={{ width: 40, height: 40, marginTop: 10 }}
                  />
                  <p className={classes.boxTitle}>Financial Accounts Module</p>
                </Box>
              </Link>
            </div>

            {/* HR & Payroll Module */}
            <div className="module-box" style={{ background: "#411C52" }}>
              <Link to="/hrpayroll">
                <Box p={4}>
                  <img
                    src={Hr2}
                    alt="HR&Payroll"
                    style={{ width: 40, height: 40, marginTop: 10 }}
                  />
                  <p className={classes.boxTitle}>HR & Payroll Module</p>
                </Box>
              </Link>
            </div>

            {/* Reports Module */}
            <div className="module-box" style={{ background: "#F0A268" }}>
              <Link to="/reports">
                <Box p={4}>
                  <img
                    src={Report2}
                    alt="Reports"
                    style={{ width: 40, height: 40, marginTop: 10 }}
                  />
                  <p className={classes.boxTitle}>Reports Module</p>
                </Box>
              </Link>
            </div>

            {/* Administration Module */}
            <div className="module-box" style={{ background: "#42337A" }}>
              <Link to="/administration">
                <Box p={4}>
                  <img
                    src={CRM2}
                    alt="Administration"
                    style={{ width: 40, height: 40, marginTop: 10 }}
                  />
                  <p className={classes.boxTitle}>Administration</p>
                </Box>
              </Link>
            </div>
            {/* CRM */}
            <div className="module-box" style={{ background: "#42337A" }}>
              <Link to="/crm/dashboard">
                <Box p={4}>
                  <img
                    src={CRM2}
                    alt="crm"
                    style={{ width: 40, height: 40, marginTop: 10 }}
                  />
                  <p className={classes.boxTitle}>CRM</p>
                </Box>
              </Link>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  currentRoute: state.returnReducer,
  authInfo: state.authInfoReducer,
});

export default connect(mapStateToProps, { currentRouteSet })(Dashboard);
